import "../../index22.css";
import { jsx as r, jsxs as I } from "react/jsx-runtime";
import { useMemo as de } from "react";
import { i as ce } from "../../type-BFTbooL7.js";
import { _ as t } from "../../cs-piwRuCFZ.js";
import me from "../DefaultMessage/index.js";
import fe from "../FilterBar/index.js";
import he from "../Footer/index.js";
import pe from "../Header/index.js";
import h from "../../hooks/useSpacingTokens.js";
const Ce = "_container_lyve2_1", _e = "_header_lyve2_8", ue = "_centered-header-description-container_lyve2_11", ge = "_centered-description_lyve2_16", we = "_with-border-and-header-background_lyve2_23", ve = "_border_lyve2_33", Ne = "_content_lyve2_39", ye = "_pending-overlaid_lyve2_42", De = "_message_lyve2_47", He = "_footer_lyve2_53", Be = "_with-grid-view_lyve2_57", ke = "_two-columns_lyve2_67", Ve = "_three-columns_lyve2_82", Ie = "_four-columns_lyve2_96", Me = "_five-columns_lyve2_100", be = "_with-vertical-view_lyve2_105", Ae = "_with-overflow-in-content_lyve2_112", e = {
  container: Ce,
  header: _e,
  centeredHeaderDescriptionContainer: ue,
  centeredDescription: ge,
  withBorderAndHeaderBackground: we,
  border: ve,
  content: Ne,
  pendingOverlaid: ye,
  message: De,
  footer: He,
  withGridView: Be,
  twoColumns: ke,
  threeColumns: Ve,
  fourColumns: Ie,
  fiveColumns: Me,
  withVerticalView: be,
  withOverflowInContent: Ae
}, Oe = {
  2: e.twoColumns,
  3: e.threeColumns,
  4: e.fourColumns,
  5: e.fiveColumns
};
function Ee(M) {
  const {
    actions: w,
    actionsContainerClassName: b,
    children: p,
    childrenContainerClassName: A,
    className: O,
    containerRef: T,
    contentViewType: l = "default",
    elementId: F,
    ellipsizeHeading: P,
    filters: v,
    filterActions: G,
    footerActions: N,
    footerActionsContainerClassName: S,
    footerClassName: x,
    footerContent: y,
    footerContentClassName: R,
    footerIcons: D,
    headerClassName: W,
    headerDescription: i,
    withCenteredHeaderDescription: C,
    headerDescriptionContainerClassName: j,
    headerElementRef: z,
    heading: H,
    headingClassName: E,
    headingContainerClassName: L,
    headingDescription: B,
    headingDescriptionContainerClassName: q,
    headingLevel: J,
    headingSectionClassName: K,
    icons: k,
    iconsContainerClassName: Q,
    numPreferredGridContentColumns: U = 2,
    spacing: n = "default",
    withHeaderBorder: X = !1,
    withFooterBorder: Y = !1,
    withBorderAndHeaderBackground: o = !1,
    withOverflowInContent: Z = !1,
    withInternalPadding: a = !1,
    withoutWrapInHeading: $ = !1,
    withoutWrapInFooter: ee = !1,
    pending: s = !1,
    overlayPending: _ = !1,
    empty: d = !1,
    errored: c = !1,
    filtered: u = !1,
    compactMessage: ne = !1,
    errorMessage: oe,
    emptyMessage: re,
    pendingMessage: te,
    filteredEmptyMessage: ie
  } = M, g = D || y || N, V = H || w || k || i || B, ae = h({ spacing: n }), m = h({
    spacing: n,
    mode: "padding-h"
  }), f = h({
    spacing: n,
    mode: "padding-v"
  }), se = h({
    spacing: n,
    mode: "gap",
    inner: !0
  }), le = de(
    () => ce(i) ? null : C ? /* @__PURE__ */ r("div", { className: e.centeredDescription, children: i }) : i,
    [i, C]
  );
  return !V && !v && !p && !g && !d && !s && !c && !u ? null : /* @__PURE__ */ I(
    "section",
    {
      id: F,
      ref: T,
      className: t(
        e.container,
        !o && ae,
        a && f,
        Z && e.withOverflowInContent,
        o && e.withBorderAndHeaderBackground,
        l === "grid" && e.withGridView,
        l === "grid" && Oe[U],
        l === "vertical" && e.withVerticalView,
        O
      ),
      children: [
        V && /* @__PURE__ */ r(
          pe,
          {
            actions: w,
            className: t(
              e.header,
              o && f,
              (a || o) && m,
              W
            ),
            elementRef: z,
            actionsContainerClassName: b,
            ellipsizeHeading: P,
            heading: H,
            headingLevel: J,
            icons: k,
            iconsContainerClassName: Q,
            childrenContainerClassName: t(
              C && e.centeredHeaderDescriptionContainer,
              j
            ),
            headingSectionClassName: K,
            headingClassName: E,
            headingContainerClassName: L,
            wrapHeadingContent: !$,
            headingDescription: B,
            headingDescriptionContainerClassName: q,
            spacing: n,
            children: le
          }
        ),
        X && /* @__PURE__ */ r("div", { className: e.border }),
        /* @__PURE__ */ r(
          fe,
          {
            filters: v,
            filterActions: G,
            spacing: n,
            className: t(a && m)
          }
        ),
        (p || d || s || c || u) && /* @__PURE__ */ I(
          "div",
          {
            className: t(
              e.content,
              l !== "default" && se,
              (a || o) && m,
              o && f,
              _ && s && e.pendingOverlaid,
              A
            ),
            children: [
              /* @__PURE__ */ r(
                me,
                {
                  className: e.message,
                  pending: s,
                  filtered: u,
                  errored: c,
                  empty: d,
                  compact: ne,
                  overlayPending: _,
                  emptyMessage: re,
                  filteredEmptyMessage: ie,
                  pendingMessage: te,
                  errorMessage: oe
                }
              ),
              !d && !c && (!s || _) && p
            ]
          }
        ),
        g && Y && /* @__PURE__ */ r("div", { className: e.border }),
        g && /* @__PURE__ */ r(
          he,
          {
            actions: N,
            icons: D,
            childrenContainerClassName: R,
            className: t(
              e.footer,
              a && m,
              o && f,
              x
            ),
            actionsContainerClassName: S,
            spacing: n,
            withoutWrap: ee,
            children: y
          }
        )
      ]
    }
  );
}
export {
  Ee as default
};
